export const receiveAppointmentCampaigns = 'APPOINTMENTREMINDERS/receiveAppointmentCampaigns';
export const receiveAppointmentCampaign = 'APPOINTMENTREMINDERS/receiveAppointmentCampaign';
